<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Lieferant erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.suppliers.store'))">
                <form-fields :form="form" 
                             :countries="countries"
                             :supplier-groups="supplierGroups"
                             :import-mode-options="importModeOptions"
                             :import-type-options="importTypeOptions"
                             :price-type-options="priceTypeOptions"
                             />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'supplierGroups',
            'priceTypeOptions',
            'importModeOptions',
            'importTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    enabled: null,
                    country_id: null,
                    supplier_group_id: null,
                    name: null,
                    slug: null,
                    short_name: null,
                    logo: null,
                    default_product_image_id: null,
                    gln: null,
                    street: null,
                    house_number: null,
                    zip_code: null,
                    city: null,
                    phone: null,
                    fax: null,
                    email: null,
                    order_email: null,
                    contact_email: null,
                    register_number: null,
                    default_product_price_type: null,
                    general_product_price: null,
                    general_product_price_text: null,
                    vat_id: null,
                    website: null,
                    terms_url: null,
                    meta_title: null,
                    meta_description: null,
                    description: null,
                    notes: null,
                    scoring: null,
                    import_mode: null,
                    default_import_type: null,
                    account_options: {},
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>